export var IPublicEnumTransformStage = /*#__PURE__*/function (IPublicEnumTransformStage) {
  IPublicEnumTransformStage["Render"] = "render";
  IPublicEnumTransformStage["Serilize"] = "serilize";
  IPublicEnumTransformStage["Save"] = "save";
  IPublicEnumTransformStage["Clone"] = "clone";
  IPublicEnumTransformStage["Init"] = "init";
  IPublicEnumTransformStage["Upgrade"] = "upgrade";
  return IPublicEnumTransformStage;
}({});
/**
 * @deprecated use IPublicEnumTransformStage instead
 */
export var TransformStage = /*#__PURE__*/function (TransformStage) {
  TransformStage["Render"] = "render";
  TransformStage["Serilize"] = "serilize";
  TransformStage["Save"] = "save";
  TransformStage["Clone"] = "clone";
  TransformStage["Init"] = "init";
  TransformStage["Upgrade"] = "upgrade";
  return TransformStage;
}({});